<sm-title-bar [customBackforbusiness]="true" pageTitle="Select a business pack" *ngIf="!loader" pageSubTitle="">
 </sm-title-bar>

<div class="price_part_lookz" *ngIf="!loader">
    <div class="create_opl">
       <div class="pricingtable-row hair-membership">
          <div class="row" style="margin-bottom: 50px; align-items: center;">
             <!-- <div class="col-sm-12">
                <div class="subscription_hedinghj">
                <h3>Select a business pack
                  </h3>
                  <p>To continue, you have to select a pack first. It can be a Free trial, or paid one- based on your preference.</p>
                </div>
             </div> -->
             <div class="col-sm-6 col-md-4 col-lg-4 m-b30" *ngFor="let item of plansList ; let i = index">
                <div class="price_card_aft" [ngStyle]="{border: item.selected == true ? '2px solid #ffc107' : ''}">
                   <div class="pricingtable-wrapper">
                     <div class="popular_cdf" *ngIf="item.validity_count == 365">
                        <span class="rotated-text">Popular</span>   
                       </div>
                      <div class="pricingtable-inner">
                         <div class="grp_heda">
                            <h3>{{item.title}}</h3>
                            <p> {{item.perUnitCost == 0 ? 'Standard support & troubleshoot' : 'Premium support & troubleshoot' }} 
                            </p>
                         </div>
                         <div class="pricingtable-price"> <span class="pricingtable-bx">{{item.currency_symbol}}{{item.perUnitCost.toFixed(2)}}</span> </div>
                         <ul class="pricingtable-features">
                            <li class="tcv_head">
                              {{item.perUnitCost == 0 ? '1 business' : 'per business'}}
                            </li>
                            <li *ngIf="item.perUnitCost == 0">
                              Lifetime validity
                            </li>
                            <li *ngIf="item.perUnitCost != 0">
                              {{ item.validity_count }} days validity
                            </li>
                         </ul>
                         <div class="pricingtable-price" style="border-top: 1px solid #efefef;padding-top: 10px;">
                           <!-- <ul class="pricingtable-features">
                              <li>
                                {{item.perUnitCost == 0 ? '* Owner can add/manage 1 business for lifetime.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Owner can add/recharge 1 business for 30 days.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Owner can add/recharge 1 business for 365 days.' : 'N/A')}}
                              </li>
                              <li>
                                {{item.perUnitCost == 0 ? '* Switch to Premium pack any time.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Opt in option for multiple months at once.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Save money over monthly packs by paying less.' : 'N/A')}} 
                              </li>
                           </ul> -->
                            <ul class="pricingtable-features">
                               <li>
                                 {{item.perUnitCost == 0 ? '* Add/Manage 1 business for lifetime.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Add/Recharge 1 business for 30 days.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Add/Recharge 1 business for 365 days.' : 'N/A')}}
                               </li>
                               <li>
                                 {{item.perUnitCost == 0 ? '* Switch to Premium pack any time.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Opt in option for multiple months at once.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Save money over monthly pack, pay less.' : 'N/A')}} 
                               </li>
                            </ul>
                         </div>
                      </div>
                      <div class="price_button" [ngClass]="{'seletedbtn': item.selected ==  true}">
                     
                         <button [disabled]="item.isExpired == 1" (click)="selectPlan(i)" type="button"><mat-icon *ngIf="item.selected ==  true">check</mat-icon> {{item.selected ==  true ? 'Selected' : 'Select Pack'}} </button>
                      </div>
                      
                   </div>
                </div>
             </div>
          </div>
       </div>


       <!-- new section start -->
       <div class="likely_section" #bottomElement>
        <div appearance="outlined" *ngIf="selectedPlan && selectedPlan != 'null'">
         <!-- ------------- 30 days business pack --------------------- -->
          <div class="row" *ngIf="selectedPlan.perUnitCost > 0 && selectedPlan.validity_count == 30">
             <div class="col-sm-7">
                  <mat-card class="rig_cardf d-none d-md-block">
                <div class="create_business_ben">
                      <div class="wht_headinght">
                        <h3>Business pack features</h3>
                        <p>The feature and functionality listed below will be available with this pack. </p>
                      </div>
                     <div class="assistant_benf">
                     <div class="row">
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>On-Shop Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Home Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Virtual Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Booking History</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Invoice & Billings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Shop Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Home Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Virtual Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Services Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Product Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Expense Tracking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Inventory Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Purchase Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Collaboration</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Payroll</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Credit Track</div>
                              <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Tax & GST</div>
                        </div>
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Online Payments</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Business Promo Posting</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Bulk Message</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>E-mail Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Discount Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Coupon Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Booking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Member Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Feedback</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Followers & Followings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Reports & Analysis</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Image</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Video</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Loyalty Rewards</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Express Support</div>
                        </div>
                     </div>
                  </div>
                </div>
                </mat-card>
             </div>
             <div class="col-sm-5">
                 <div class="pricing_card_rg" [ngClass]="{ 'fixed-card': isCardFixed }" #cardRef>
                 <mat-card class="rig_cardf sticky-card">
                <div class="choose_sucri emsection">
                      <div class="nus_nu_sectionm">
                        <div class="create_thy">
                         <h3>{{selectedPlan.title}}</h3>
                         <p class="prev_heading">Premium support & troubleshoot</p>
                         <p>You have the liberty to choose up to 11 months of pack at once. Purchased pack can be used to create new business as well recharge an existing one.</p>
                        </div>
                         <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                         <!-- <h4>per business for 30 days</h4> -->
                         <p>Select pack duration</p>
                         <div class="no_monther">
                            <mat-form-field appearance="outline" style="width: 150px;">
                                <mat-select placeholder="No of month" [(ngModel)]="noOfMonths" (ngModelChange)="changeMonths($event)">
                                    <mat-option [value]="1">
                                        1 month
                                    </mat-option>
                                    <mat-option [value]="2">
                                        2 months
                                    </mat-option>
                                    <mat-option [value]="3">
                                        3 months
                                    </mat-option>
                                    <mat-option [value]="4">
                                        4 months
                                    </mat-option>
                                    <mat-option [value]="5">
                                        5 months
                                    </mat-option>
                                    <mat-option [value]="6">
                                        6 months
                                    </mat-option>
                                    <mat-option [value]="7">
                                        7 months
                                    </mat-option>
                                    <mat-option [value]="8">
                                        8 months
                                    </mat-option>
                                    <mat-option [value]="9">
                                        9 months
                                    </mat-option>
                                    <mat-option [value]="10">
                                        10 months
                                    </mat-option>
                                    <mat-option [value]="11">
                                        11 months
                                    </mat-option>
                                    <!-- <mat-option [value]="12">
                                        12 months
                                    </mat-option> -->
                                </mat-select>
                            </mat-form-field>
                            
                         </div>
                       <div class="sed_button" *ngIf="countryInfo.currency == 'INR'">
                            <button flat type="button" (click)="onContinue()">Checkout</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                                <p style="margin-bottom: 25px;">Purchase using PayPal or Debit/Credit card.</p>
                           <sm-paypal-entity-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-entity-subscription-purchase>
                           </div>
                         <p>* No refund if pack used.</p>
                         <p>* No refund after 7 days of purchase.</p>
                         <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                         <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                         <div class="secr_check_secu">
                            <p>
                               <mat-icon>lock</mat-icon>
                               Safe & Secure checkout.
                            </p>
                         </div>
                      </div>
                </div>
                </mat-card>
                </div>
             </div>
          </div>
         <!-- -------------------- 1 year business pack --------------------- -->
          <div class="row" *ngIf="selectedPlan.perUnitCost > 0 && selectedPlan.validity_count == 365">
             <div class="col-sm-7">
               <mat-card class="rig_cardf d-none d-md-block">
                <div class="create_business_ben">
                      <div class="wht_headinght">
                        <h3>Business pack features</h3>
                        <p>The feature and functionality listed below will be available with this pack. </p>
                      </div>
                   <div class="assistant_benf">
                     <div class="row">
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>On-Shop Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Home Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Virtual Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Booking History</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Invoice & Billings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Shop Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Home Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Virtual Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Services Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Product Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Expense Tracking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Inventory Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Purchase Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Collaboration</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Payroll</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Credit Track</div>
                              <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Tax & GST</div>
                        </div>
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Online Payments</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Business Promo Posting</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Bulk Message</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>E-mail Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Discount Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Coupon Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Booking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Member Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Feedback</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Followers & Followings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Reports & Analysis</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Image</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Video</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Loyalty Rewards</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Express Support</div>
                        </div>
                     </div>
                  </div>
                </div>
                </mat-card>
             </div>
             <div class="col-sm-5">
               <div class="pricing_card_rg" [ngClass]="{ 'fixed-card': isCardFixed }" #cardRef>
                <mat-card class="rig_cardf sticky-card">
                <div class="choose_sucri emsection">
                      <div class="nus_nu_sectionm">
                        <div class="create_thy">
                         <h3>{{selectedPlan.title}}</h3>
                         <p class="prev_heading">Premium support & troubleshoot</p>
                         <p>Purchased pack can be used to create new business as well recharge an existing one. With yearly pack you can save money over monthly pack.</p>
                        </div>
                         <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                         <h4>per business for 365 days</h4>
                         <!-- <p>{{selectedPlan.validity_count }} days validity</p> -->
                        <div class="sed_button" *ngIf="countryInfo.currency == 'INR'">
                            <button flat type="button" (click)="onContinue()">Checkout</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                                <p style="margin-bottom: 25px;">Purchase using PayPal or Debit/Credit card.</p>
                           <sm-paypal-entity-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-entity-subscription-purchase>
                           </div>
                         <p>* No refund if pack used.</p>
                         <p>* No refund after 7 days of purchase.</p>
                         <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                         <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                         <div class="secr_check_secu">
                            <p>
                               <mat-icon>lock</mat-icon>
                               Safe & Secure checkout.
                            </p>
                         </div>
                      </div>
                </div>
                </mat-card>
                </div>
             </div>
          </div>
         <!-- ------------------- Free business trial pack -------------------- -->
          <div class="row" *ngIf="selectedPlan.perUnitCost == 0 && selectedPlan.validity_count == 30">
             <div class="col-sm-7">
                <mat-card class="rig_cardf d-none d-md-block">
                <div class="create_business_ben">
                      <div class="wht_headinght">
                        <h3>Business pack features</h3>
                        <p>The feature and functionality listed below will be available with this pack. </p>
                      </div>
                      <!-- <div class="assistant_benf">
                         <div class="row">
                            <div class="col-sm-6">
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Booking management.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Operation hours & scheduling.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Service management.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Tax & Discount.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Invoicing & Billing.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Online payment.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Customer feedback.
                               </div>
                            </div>
                            <div class="col-sm-6">
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Expenditure tracking.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Inventory management.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Purchase handling.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Customer management.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Employee collaboration.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Offline data sync.
                               </div>
                               <div class="cardfg_se">
                                  <mat-icon>check</mat-icon>
                                  Reports and Insight data.
                               </div>
                            </div>
                         </div>
                      </div> -->
                       <div class="assistant_benf">
                     <div class="row">
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>On-Shop Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Home Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Virtual Service Bookings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Booking History</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Invoice & Billings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Shop Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Home Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Set Virtual Service Timings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Services Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Product Catalog</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Expense Tracking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Inventory Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Purchase Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Collaboration</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Payroll</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Credit Track</div>
                              <div class="cardfg_se"><mat-icon>check</mat-icon>Employee Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Tax & GST</div>
                        </div>
                        <div class="col-sm-6">
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Online Payments</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Business Promo Posting</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Bulk Message</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>WhatsApp Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>E-mail Sharing</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Discount Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Coupon Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Booking</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>QR Code Attendance</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Member Management</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Customer Feedback</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Followers & Followings</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Reports & Analysis</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Image</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Upload Business Video</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Loyalty Rewards</div>
                           <div class="cardfg_se"><mat-icon>check</mat-icon>Express Support</div>
                        </div>
                     </div>
                  </div>
                </div>
                </mat-card>
             </div>
             <div class="col-sm-5">
                 <div class="pricing_card_rg" [ngClass]="{ 'fixed-card': isCardFixed }" #cardRef>
                  <mat-card class="rig_cardf sticky-card">
                <div class="choose_sucri emsection">
                      <div class="nus_nu_sectionm">
                        <div class="create_thy">
                         <h3>{{selectedPlan.title}}</h3>
                         <p class="prev_heading">Standard support & troubleshoot</p>
                         <p>Use all the premium features for free for one month. You can continue with the basic functionalities even after the expiry of free pack.  </p>
                        </div>
                        <!-- ₹ -->
                         <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                         <h4>1 business for lifetime</h4>
                         <!-- <p>{{selectedPlan.validity_count}} days validity</p> -->
                         <div class="sed_button">
                            <button flat type="button" (click)="onContinue()">Start free trial</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                           <sm-paypal-entity-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-entity-subscription-purchase>
                           </div>
                         <p>* No refund. </p>
                         <p>* One time use.</p>
                         <p>* No debit/credit card required.</p>
                         <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                         <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                         <div class="secr_check_secu">
                            <p>
                               <mat-icon>lock</mat-icon>
                               Safe & Secure checkout.
                            </p>
                         </div>
                      </div>
                </div>
                </mat-card>
                </div>
             </div>
          </div>
         </div>
          <!-- <mat-card appearance="outlined" *ngIf="!selectedPlan || selectedPlan == 'null'">
            <div class="row">
               <div class="col-sm-7">
                  <div class="create_business_ben">
                        <div class="wht_headinght">
                           <h3 style="font-weight: normal;">Select a pack to get the details.</h3>
                               <p>Here are the options of Packs to create a new business or recharge an existing one.   <br>
                                Once you select one, the details about the pack and it's features will appear below.</p>
                        </div>
                  </div>
         </div>
            </div>            
          </mat-card> -->
       </div>
       <!-- new section end -->
    </div>
 </div>